// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"979":"259ffa74","2479":"6cdc6562","7643":"ae5307fb","7872":"ed4cce18","8485":"c32367a7","8966":"624b4992","9386":"4843146e"}[chunkId] + ".chunk.css";
};